import { render, staticRenderFns } from "./ActitiveTabcomponent.vue?vue&type=template&id=54eef5fe&scoped=true"
import script from "./ActitiveTabcomponent.vue?vue&type=script&lang=js"
export * from "./ActitiveTabcomponent.vue?vue&type=script&lang=js"
import style0 from "./ActitiveTabcomponent.vue?vue&type=style&index=0&id=54eef5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eef5fe",
  null
  
)

export default component.exports